// extracted by mini-css-extract-plugin
export var bodyFont = "index-module--body-font--09899";
export var covid_message = "index-module--covid_message--5c1a4";
export var no_min_height = "index-module--no_min_height--4f768";
export var outer_wrapper = "index-module--outer_wrapper--d59c3";
export var titleFont = "index-module--title-font--f909a";
export var wrapper = "index-module--wrapper--cec06";